import { map, type Observable } from 'rxjs';

import {
  type MenuData,
  type MenuDeclaration,
  type MyreRoute,
  type ResolvedMenuRoute,
} from '../interfaces';

/** Reads the menu labels of the routes from the wordings of the app that declares them. */
export function computeNamesForRoutes$<W>(
  menuData$: Observable<MenuDeclaration<W>>,
  wordings: W,
): Observable<MenuData> {
  return menuData$.pipe(
    map(menuData => ({
      ...menuData,
      routes: resolveRoutes(menuData.routes, wordings),
    })),
  );
}

function resolveRoutes<W>(
  routes: readonly MyreRoute<W>[],
  wordings: W,
): ResolvedMenuRoute[] {
  return routes.map(route => {
    const { menuItemData, children, ...rest } = route;

    if (!menuItemData) {
      return {
        ...rest,
        children: children && resolveRoutes(children, wordings),
      };
    }

    const { label, node, ...display } = menuItemData;

    return {
      ...rest,
      menuItem: {
        ...display,
        label: label(wordings),
        node: node && { key: node.key, label: node.label(wordings) },
      },
      children: children && resolveRoutes(children, wordings),
    };
  });
}
